/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';

// Components
import Filters from '../../components/Filters/Filters';
import FormDropdown from '../../components/Form/FormDropdown';
import Header from '../../components/Header/Header';
import Error from '../../components/Error/Error';
import FormSearch from '../../components/Form/FormSearch';

// Table
import Table from '../../components/Table/Table';
import TableCatalog from '../../components/Table/TableCatalog';
import Pagination from '../../components/Pagination/Pagination';

// api
import { useGetProducts } from '../../api/hooks/products.hooks';
import { useGetFiltres } from '../../api/hooks/filtres.hooks';

// contexts
import { useProductsFiltersContext } from '../../contexts/filters/productsFiltersContext';

// utils
import { convertArraysIntoStrings, removeUndefined } from '../../utils/object';

// hooks
import useDebounce from '../../hooks/useDebounce';
import FormCheckbox from '../../components/Form/FormCheckbox';

export default function Catalog() {
    const { productsFilters, setProductsFilters } = useProductsFiltersContext();
    const [page, setPage] = useState(1);
    const [formattedFilters, setFormatedFilters] = useState({});

    const { data: filters, isLoading: loadingFilters, isError: errorFilters } = useGetFiltres();

    const {
        data: catalog,
        isError: errorCatalog,
        isLoading: loadingCatalog,
    } = useGetProducts({ numero_page: page, ...formattedFilters });

    const methods = useForm({
        defaultValues: {
            type_affaire_id: [],
            categorie_id: [],
            ...productsFilters,
        },
    });

    const selectedFilters = useWatch({ control: methods.control });
    const debouncedSelectedFilters = useDebounce(selectedFilters, 700);
    useEffect(() => {
        setProductsFilters(debouncedSelectedFilters);
        setPage(1);
        const newFilters = convertArraysIntoStrings(selectedFilters);
        return setFormatedFilters(removeUndefined(newFilters));
    }, [debouncedSelectedFilters]);

    if (errorCatalog) return <Error message='Erreur lors de la récupération du catalogue' />;
    if (errorFilters) return <Error message='Erreur lors de la récupération des filtres' />;

    return (
        <>
            <Header>
                <h1 className='text-lg'>Catalogue des produits</h1>
            </Header>
            <Filters>
                <div className='flex space'>
                    <FormProvider {...methods}>
                        <FormSearch placeholder='Nom, Référence, ...' name='recherche' />
                        {loadingFilters ? (
                            <p>Chargement</p>
                        ) : (
                            <div className='flex'>
                                <form className='flex sl-2 mr-2'>
                                    <FormCheckbox name='produit_casino'>Casino</FormCheckbox>
                                    {filters.type_affaire && (
                                        <FormDropdown
                                            name='type_affaires_ids'
                                            label='Famille'
                                            list={filters.type_affaire ? filters.type_affaire : []}
                                        />
                                    )}
                                    {filters.type_affaire && (
                                        <FormDropdown
                                            name='type_affaire_id'
                                            label='Famille'
                                            list={filters.type_affaire ? filters.type_affaire : []}
                                        />
                                    )}
                                    {filters.categorie && (
                                        <FormDropdown
                                            name='categorie_id'
                                            label='Catégories'
                                            list={filters.categorie ? filters.categorie : []}
                                        />
                                    )}
                                </form>
                                <Pagination setPage={setPage} page={page} totalPages={catalog?.nb_page} />
                            </div>
                        )}
                    </FormProvider>
                </div>
            </Filters>
            <section className='section'>
                <Table data={catalog?.produits}>
                    <TableCatalog loading={loadingCatalog} />
                </Table>
            </section>
        </>
    );
}
